import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Badge, Button } from '@app/shared/ui/atoms/Common';
import { InfoRow } from '@app/shared/ui/molecules/Common';
import { formatBalance } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { PriceType } from '@app/shared/types/common';

interface UserInfoSectionProps {
  user: {
    id: number;
    telegramTag: string | null;
    telegramId: string | null;
    name?: string | null;
    curator?: string | null;
    cookieBalance: number;
    tonBalance: number;
  };
}

export function UserInfoSection({ user }: UserInfoSectionProps) {
  const { t } = useTranslation();

  return (
    <section>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">{t('admin_balance.found_user')}</span>
        <Button size="sm" className="flex w-fit items-center justify-center px-4" asChild>
          <Link to={`${Page.ADMIN_USERS}/${String(user.id)}`}>{t('admin_balance.view_info')}</Link>
        </Button>
      </div>
      <InfoRow label="ID" value={<b>{user.id}</b>} />
      <InfoRow label={t('admin_common.telegram_tag')} value={<b>{user.telegramTag}</b>} />
      <InfoRow label="Telegram ID" value={<b>{user.telegramId}</b>} />
      <InfoRow label={t('common.name')} value={<b>{user.name}</b>} />
      <InfoRow label={t('common.curator')} value={<b>{user.curator}</b>} />
      <InfoRow
        label={t('admin_balance.current_balance')}
        value={
          <div className="flex gap-2 text-center">
            <Badge>{formatBalance(PriceType.COOKIE, user.cookieBalance)}</Badge>
            <Badge>{formatBalance(PriceType.TON, user.tonBalance)}</Badge>
          </div>
        }
        withBottomBorder={false}
      />
    </section>
  );
}
